import { createFileRoute } from '@tanstack/react-router';
import Favourites from '../../components/favourites/favourites';
import { seo } from '../../utils/seo';

// Favourites are per-visitor (kept in localStorage), so they can't be prerendered: only the page shell is static,
// the favourite products are fetched in the browser (see components/favourites/favourites.tsx).
export const Route = createFileRoute('/_layout/favourites')({
  head: () => ({ meta: seo({ title: 'Kedvencek' }) }),
  component: FavouritesRoute
});

function FavouritesRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Kedvencek</h1>
        <Favourites />
      </div>
    </div>
  );
}
